const initialData = {
  results: [
    {
      id: 715497,
      title: "Berry Banana Breakfast Smoothie",
      image: "https://spoonacular.com/recipeImages/715497-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 715415,
      title: "Red Lentil Soup with Chicken and Turnips",
      image: "https://spoonacular.com/recipeImages/715415-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 716406,
      title: "Asparagus and Pea Soup: Real Convenience Food",
      image: "https://spoonacular.com/recipeImages/716406-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 644387,
      title: "Garlicky Kale",
      image: "https://spoonacular.com/recipeImages/644387-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 715446,
      title: "Slow Cooker Beef Stew",
      image: "https://spoonacular.com/recipeImages/715446-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 782601,
      title: "Red Kidney Bean Jambalaya",
      image: "https://spoonacular.com/recipeImages/782601-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 716426,
      title: "Cauliflower, Brown Rice, and Vegetable Fried Rice",
      image: "https://spoonacular.com/recipeImages/716426-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 795751,
      title: "Chicken Fajita Stuffed Bell Pepper",
      image: "https://spoonacular.com/recipeImages/795751-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 766453,
      title: "Hummus and Za'atar",
      image: "https://spoonacular.com/recipeImages/766453-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 716627,
      title: "Easy Homemade Rice and Beans",
      image: "https://spoonacular.com/recipeImages/716627-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 664147,
      title: "Tuscan White Bean Soup with Olive Oil and Rosemary",
      image: "https://spoonacular.com/recipeImages/664147-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 640941,
      title: "Crunchy Brussels Sprouts Side Dish",
      image: "https://spoonacular.com/recipeImages/640941-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 715495,
      title: "Turkey Tomato Cheese Pizza",
      image: "https://spoonacular.com/recipeImages/715495-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 794349,
      title: "Broccoli and Chickpea Rice Salad",
      image: "https://spoonacular.com/recipeImages/794349-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 716381,
      title: "Nigerian Snail Stew",
      image: "https://spoonacular.com/recipeImages/716381-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 660306,
      title: "Slow Cooker: Pork and Garbanzo Beans",
      image: "https://spoonacular.com/recipeImages/660306-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 756814,
      title: "Powerhouse Almond Matcha Superfood Smoothie",
      image: "https://spoonacular.com/recipeImages/756814-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 715769,
      title: "Broccolini Quinoa Pilaf",
      image: "https://spoonacular.com/recipeImages/715769-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 642129,
      title: "Easy To Make Spring Rolls",
      image: "https://spoonacular.com/recipeImages/642129-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 642605,
      title: "Farro With Mushrooms and Asparagus",
      image: "https://spoonacular.com/recipeImages/642605-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 636589,
      title: "Butternut Squash Frittata",
      image: "https://spoonacular.com/recipeImages/636589-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 646738,
      title: "Herbivoracious' White Bean and Kale Soup",
      image: "https://spoonacular.com/recipeImages/646738-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 715540,
      title: "Summer Berry Salad",
      image: "https://spoonacular.com/recipeImages/715540-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 663559,
      title: "Tomato and lentil soup",
      image: "https://spoonacular.com/recipeImages/663559-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 662670,
      title: "Swiss Chard Wraps",
      image: "https://spoonacular.com/recipeImages/662670-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 640062,
      title: "Corn Avocado Salsa",
      image: "https://spoonacular.com/recipeImages/640062-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 715421,
      title: "Cheesy Chicken Enchilada Quinoa Casserole",
      image: "https://spoonacular.com/recipeImages/715421-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 648320,
      title: "Jade Buddha Salmon Tartare",
      image: "https://spoonacular.com/recipeImages/648320-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 716432,
      title: "Finger Foods: Frittata Muffins",
      image: "https://spoonacular.com/recipeImages/716432-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 798400,
      title: "Spicy Black-Eyed Pea Curry with Swiss Chard and Roasted Eggplant",
      image: "https://spoonacular.com/recipeImages/798400-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 782600,
      title: "Quinoa Salad with Vegetables and Cashews",
      image: "https://spoonacular.com/recipeImages/782600-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 652417,
      title: "Moroccan chickpea and lentil stew",
      image: "https://spoonacular.com/recipeImages/652417-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 639535,
      title: "Citrusy Pecan Garbanzo Couscous: A Salad For Cold Weather",
      image: "https://spoonacular.com/recipeImages/639535-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 729366,
      title: "Plantain Salad",
      image: "https://spoonacular.com/recipeImages/729366-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 661925,
      title: "Strawberry-Mango Quinoa Salad",
      image: "https://spoonacular.com/recipeImages/661925-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 794538,
      title: "Almond Joy Protein Shake",
      image: "https://spoonacular.com/recipeImages/794538-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 649931,
      title: "Lentil Salad With Vegetables",
      image: "https://spoonacular.com/recipeImages/649931-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 636787,
      title: "Caldo Verde - Portuguese Kale Soup",
      image: "https://spoonacular.com/recipeImages/636787-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 641975,
      title: "Easy Ginger Beef Broccoli",
      image: "https://spoonacular.com/recipeImages/641975-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 652423,
      title: "Moroccan Couscous and Chickpea Salad",
      image: "https://spoonacular.com/recipeImages/652423-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 715447,
      title: "Easy Vegetable Beef Soup",
      image: "https://spoonacular.com/recipeImages/715447-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 716311,
      title: "Mango Fried Rice",
      image: "https://spoonacular.com/recipeImages/716311-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 715543,
      title: "Homemade Guacamole",
      image: "https://spoonacular.com/recipeImages/715543-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 157344,
      title: "Spicy Salad with Kidney Beans, Cheddar, and Nuts",
      image: "https://spoonacular.com/recipeImages/157344-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 658509,
      title: "Roasted Broccoli with Lemon and Garlic",
      image: "https://spoonacular.com/recipeImages/658509-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 716195,
      title: "Spicy Indian-Style Hummus",
      image: "https://spoonacular.com/recipeImages/716195-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 716361,
      title: "Stir Fried Quinoa, Brown Rice and Chicken Breast",
      image: "https://spoonacular.com/recipeImages/716361-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 765011,
      title: "Snap Pea and Green Bean Salad with Arugula Pesto",
      image: "https://spoonacular.com/recipeImages/765011-312x231.jpg",
      imageType: "jpg",
    },
    {
      id: 660228,
      title: "Skinny Kale Basil Pesto",
      image: "https://spoonacular.com/recipeImages/660228-312x231.jpg",
      imageType: "jpg",
    },
  ],
  offset: 0,
  number: 50,
  totalResults: 5221,
};

export default initialData;
